/* eslint eqeqeq:"off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { toast, ToastContainer } from "react-toastify";
import { isEmpty } from "lodash";
import { Badge, Col, Divider, Row, Skeleton, Table } from "antd";
import { dashboardHeaders } from "../Parties/data";
import "./index.css";
import {
  loadDashboardTransactions,
  loadTotalBalance,
} from "../../store/purchase-orders/actions";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import moment from "moment";
import {
  AreaChart,
  Area,
  // Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { GiBank, GiPriceTag } from "react-icons/gi";
import {
  loadPartiesCollect,
  loadPartiesPay,
} from "../../store/parties/actions";
// import { Column } from "@ant-design/charts";
// import * as Column from "@ant-design/charts";
import { PiUserSoundFill } from "react-icons/pi";
// import SalesReportImg from "../../assets/images/sales-report.png";
import useMedia from "use-media-antd-query";
import { RiStockFill } from "react-icons/ri";
import { loadSalesFiltersReport } from "../../store/reports/actions";

const Dashboard = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const media = useMedia();
  //organisation id from login response
  const userValues = localStorage.getItem("authData");
  const notifications = localStorage.getItem("welcomeNotification");
  const userNameDetails = JSON.parse(userValues);

  const organizationId =
    !isEmpty(userNameDetails) && userNameDetails.user.organizations.length > 0
      ? userNameDetails.user.organizations[0].organizationId
      : "";

  const transationList = { organizationId: organizationId };

  //Initial state
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    if (notifications === true || notifications === "true") {
      const timer = setTimeout(() => {
        toast.info(`Welcome Back ! `);
        localStorage.setItem("welcomeNotification", "");
        dispatch(loadDashboardTransactions(transationList));
        dispatch(loadTotalBalance(transationList));
        dispatch(loadPartiesCollect(transationList));
        dispatch(loadPartiesPay(transationList));
        dispatch(
          loadSalesFiltersReport({
            page: 1,
            limit: 100,
            organizationId: organizationId,
          })
        );
      }, 1000);
      return () => clearTimeout(timer);
    }
    dispatch(
      loadSalesFiltersReport({
        page: 1,
        limit: 100,
        organizationId: organizationId,
      })
    );
    dispatch(loadDashboardTransactions(transationList));
    dispatch(loadTotalBalance(transationList));
    dispatch(loadPartiesCollect(transationList));
    dispatch(loadPartiesPay(transationList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Date values
  const todayDate = moment().format("DD MMM YYYY");
  const beforeWeek = moment().subtract(1, "week").format("DD MMM YYYY");

  //Reducer state
  const { dashboard_transactions = [], total_balance_list = [] } = useSelector(
    (state) => state.PurchaseOrders
  );
  const { parties_pay_list = [], parties_collect_list = [] } = useSelector(
    (state) => state.Parties
  );
  const { sales_filter_report = {} } = useSelector((state) => state.Reports);

  const [sortedInfo, setSortedInfo] = useState({});
  const onChange = (pagination, filters, sorter, extra) => {
    setSortedInfo({
      order: "descend",
      columnKey: sorter.column.dataIndex,
    });
  };
  //header columns
  const HeaderData = [
    {
      key: "date",
      title: <p className="dashboard-label">DATE</p>,
      dataIndex: "date",
      sortDirections: ["ascend"],
      width: "18%",
      sorter: (a, b) => a.date.length - b.date.length,
      sortOrder: sortedInfo.columnKey === "date" ? sortedInfo.order : null,
    },
    {
      key: "type",
      title: <p className="dashboard-label">TYPE</p>,
      width: "18%",
      dataIndex: "type",
    },
    {
      key: "poNo",
      title: <p className="dashboard-label">TXN NO</p>,
      // title: "Purchase Order Number",
      width: "18%",
      dataIndex: "poNo",
    },
    {
      key: "vendorName",
      title: <p className="dashboard-label">VENDOR / PARTY NAME</p>,
      width: "26%",
      dataIndex: "vendorName",
    },
    {
      key: "NetAmount",
      title: <p className="dashboard-label">AMOUNT</p>,
      width: "20%",
      dataIndex: "NetAmount",
    },
    // {
    //   key: "status",
    //   title: "Status",
    //   dataIndex: "status",
    // },
  ];

  const purchaseRoutes = (data) => {
    const stateDataValue =
      data.transActionType == "Expenses"
        ? { data: data }
        : data.transActionType === "Sales invoices" ||
          data.transActionType === "Sales Return"
        ? { salesInvoice: data }
        : data.transActionType === "Purchase invoices"
        ? { purchaseInvoice: data }
        : data.transActionType == "Payment In" ||
          data.transActionType == "Payment Out"
        ? { paymentData: data }
        : "";
    history.push({
      pathname: `${
        data.transActionType == "Expenses"
          ? "/expenses"
          : data.transActionType === "Sales invoices"
          ? "/sales-invoice"
          : data.transActionType === "Sales Return"
          ? "/sales-return"
          : data.transActionType === "Purchase invoices"
          ? "/purchase-invoice"
          : data.transActionType == "Payment In"
          ? "/payment-in"
          : data.transActionType == "Payment Out" && "/payment-out"
      }/data`,
      state: stateDataValue,
    });
  };

  const filteredDataArrays =
    dashboard_transactions && dashboard_transactions.length > 0
      ? dashboard_transactions.slice(0, 3)
      : [];

  // Initial date range (you can update via UI)
  const initialStartDate = beforeWeek;
  const initialEndDate = todayDate;

  // Function to filter sales between selected dates
  const filterSalesData = (data, startDate, endDate) => {
    return data.filter((sale) => {
      const saleDate = new Date(sale.createdAt);
      return saleDate >= new Date(startDate) && saleDate <= new Date(endDate);
    });
  };

  // Filtered sales based on selected dates
  const salesData =
    !isEmpty(sales_filter_report) && sales_filter_report.data.length > 0
      ? sales_filter_report.data
      : [];
  const filteredSales = filterSalesData(
    salesData,
    initialStartDate,
    initialEndDate
  );

  // Group data by day & month
  const groupedSalesData =
    filteredSales &&
    filteredSales.reduce((acc, sale) => {
      const date = new Date(sale.createdAt);
      const dayMonth = `${date.getDate()} ${date.toLocaleString("default", {
        month: "short",
      })}`;

      if (!acc[dayMonth]) {
        acc[dayMonth] = { date: dayMonth, totalAmount: 0 };
      }
      acc[dayMonth].totalAmount += sale.totalAmount;
      return acc;
    }, {});

  const formattedSalesData =
    groupedSalesData &&
    Object.values(groupedSalesData).sort(
      (a, b) => new Date(a.date) - new Date(b.date)
    );

  // transaction data table
  const purchaseDataTable =
    filteredDataArrays && filteredDataArrays.length > 0
      ? filteredDataArrays.map((data, index) => {
          return {
            _id: data._id,
            key: index + 1,
            NetAmount: (
              <div onClick={() => purchaseRoutes(data)} className="flex">
                <p
                  style={{
                    fontFamily: "Roboto",
                    fontSize: "14px",
                  }}
                >
                  ₹{" "}
                </p>
                <h1 className="cursor-pointer ml-1 mt-[1px]">
                  {data.enterPaymentAmount
                    ? data.enterPaymentAmount.toLocaleString("en-IN")
                    : data.totalAmount
                    ? data.totalAmount.toLocaleString("en-IN")
                    : data.NetAmount != undefined
                    ? data.NetAmount.toLocaleString("en-IN")
                    : data.netTotalAmount
                    ? data.netTotalAmount.toLocaleString("en-IN")
                    : "0"}
                </h1>
              </div>
            ),
            authorizedsignature: data.authorizedsignature,
            autoamountroundoff: data.autoamountroundoff,
            beforeautoroundoffamount: data.beforeautoroundoffamount,
            charge: data.charge,
            createdAt: data.createdAt
              ? moment(data.createdAt).format("DD-MM-YYYY")
              : "",
            createdBy: data.createdBy,
            financialyearId: data.financialyearId,
            isHistory: data.isHistory,
            items: data.items,
            notes: data.notes,
            organizationId: data.organizationId,
            date: (
              <h1
                className="cursor-pointer"
                onClick={() => purchaseRoutes(data)}
              >
                {data.paymentDate
                  ? moment(data.paymentDate).format("MMM Do YY")
                  : data.expenseDate
                  ? moment(data.expenseDate).format("MMM Do YY")
                  : data.purchaseinvoiceDate
                  ? moment(data.purchaseinvoiceDate).format("MMM Do YY")
                  : data.salesinvoiceDate
                  ? moment(data.salesinvoiceDate).format("MMM Do YY")
                  : ""}
              </h1>
            ),
            poNo: (
              <h1
                className="cursor-pointer"
                onClick={() => purchaseRoutes(data)}
              >
                {data.expenseNo && data.prefixName
                  ? data.prefixName + "" + data.expenseNo
                  : data.expenseNo &&
                    (data.prefixName == undefined || data.prefixName == "")
                  ? data.expenseNo
                  : data.purchaseinvoiceNo && data.prefixName
                  ? data.prefixName + "" + data.purchaseinvoiceNo
                  : data.purchaseinvoiceNo &&
                    (data.prefixName == undefined || data.prefixName == "")
                  ? data.purchaseinvoiceNo
                  : data.paymentNo
                  ? data.paymentNo
                  : data.salesinvoiceNo
                  ? data.salesinvoiceNo
                  : ""}
              </h1>
            ),
            subtotalamount: data.subtotalamount,
            taxableAmonut: data.taxableAmonut,
            termsandconditions: data.termsandconditions,
            totaltax: data.totaltax,
            totaltaxableValue: data.totaltaxableValue,

            type: (
              <h1
                className="cursor-pointer"
                onClick={() => purchaseRoutes(data)}
              >
                {data.transActionType}
              </h1>
            ),
            transActionType: data.transActionType,
            updatedAt: data.updatedAt,
            vendorAddress: data.vendorAddress,
            vendorCity: data.vendorCity,
            vendorId: data.vendorId,
            vendorName: (
              <h1
                className="cursor-pointer"
                onClick={() => purchaseRoutes(data)}
              >
                {data.vendorName ? data.vendorName : data.partyName}
              </h1>
            ),
            vendorNameValue: data.vendorName ? data.vendorName : data.partyName,

            status: (
              <Badge
                className={
                  data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusName === "Active"
                    ? "bg-[#edf6ef] font-semibold rounded-md text-[#49a563] p-2"
                    : "bg-[#f1e7e9] font-semibold rounded-md text-[#d01717] p-2"
                }
              >
                {data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusName}
              </Badge>
            ),
          };
        })
      : [];

  //Charts
  // const data = [
  //   { year: "1991", value: 3 },
  //   { year: "1992", value: 4 },
  //   { year: "1993", value: 3.5 },
  //   { year: "1994", value: 5 },
  //   { year: "1995", value: 4.9 },
  //   { year: "1996", value: 6 },
  //   { year: "1997", value: 7 },
  //   { year: "1998", value: 9 },
  //   { year: "1999", value: 13 },
  // ];

  // const config = {
  //   data,
  //   xField: "year",
  //   yField: "value",
  //   xAxis: {
  //     label: {
  //       autoHide: true,
  //       autoRotate: false,
  //     },
  //   },
  // };

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //number format
  // var inrFormat = new Intl.NumberFormat()

  return (
    <React.Fragment>
      {/* <Layout> */}
      <div className="pl-5">
        <MetaTags>
          <title>Dashboard | Mbook</title>
        </MetaTags>
      </div>
      {/* <Row className="bg-[#ffffff]"> */}
      <Row className="bg-[#ffffff]">
        <Col span={24} className="border pb-2 border-b-1 border-x-0 border-t-0">
          <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-2">
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[20px] ml-2 mt-1 font-semibold"
              >
                Dashboard
              </h1>
            </div>
            <div className="flex">
              <div className="flex text-[12px] border bg-[#ffffff] text-[#000000] rounded-md ml-3 pl-6 pr-6 p-1 cursor-pointer">
                <PiUserSoundFill className="mt-1 mr-2" /> Share Suggestion
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Row
        className={
          windowDimensions.height >= 700 && windowDimensions.height <= 767
            ? "dashboard-main-card-medium-device bg-[#ffffff]"
            : windowDimensions.height > 767 && windowDimensions.height < 830
            ? "dashboard-main-card-large-device bg-[#ffffff]"
            : windowDimensions.height > 830 && windowDimensions.height < 900
            ? "dashboard-main-card-extra-large-device bg-[#ffffff]"
            : windowDimensions.height > 900 && windowDimensions.height < 960
            ? "dashboard-main-card-extra-extra-large-device bg-[#ffffff]"
            : windowDimensions.height >= 960 && windowDimensions.height < 1000
            ? "dashboard-main-card-extra-infinite-large-device bg-[#ffffff]"
            : windowDimensions.height >= 1000
            ? "dashboard-main-card-price-extra-infinite-large-device bg-[#ffffff]"
            : "bg-[#ffffff] dashboard-main-card"
        }
      >
        <Col span={24} className="pb-2">
          <Row className="pl-5 mt-5 mb-5">
            {dashboardHeaders.map((data) => {
              return (
                <Col span={12} key={data.key} className="">
                  {loading ? (
                    <Skeleton.Input
                      style={{
                        marginRight: "5px",
                        minWidth: "255%",
                        height: "50px",
                      }}
                      active={true}
                      size={"large"}
                    ></Skeleton.Input>
                  ) : (
                    <div
                      className={
                        // purchaseTab === data.label
                        // ? "poppins flex mr-4 parties-select-card parties-card border rounded-md"
                        // :
                        "poppins flex justify-between mr-4 dashboard-card border rounded-md"
                      }
                      // onClick={() => {
                      //   // setPurchaseTab(data.label);
                      //   setLoading(true);
                      //   setTimeout(() => {
                      //     setLoading(false);
                      //   }, 2000);
                      // }}
                    >
                      <div
                        style={{
                          fontSize: "14px",
                          display: "flex",
                          color: data.color,
                          fontFamily: "Poppins",
                        }}
                      >
                        <p
                          className={
                            data.key !== 1
                              ? "text-[20px] font-semibold"
                              : "font-semibold"
                          }
                        >
                          {data.icon}
                        </p>
                        <h2 className={"ml-2"}>{data.label}</h2>
                      </div>
                      <div>
                        <h1 className="font-semibold text-[18px]">
                          {data.key == 1 &&
                          parties_collect_list &&
                          parties_collect_list.totalAmounttoCollect !== null
                            ? "₹ " +
                              (parties_collect_list.totalAmounttoCollect &&
                                parties_collect_list.totalAmounttoCollect.toLocaleString(
                                  "en-IN"
                                ))
                            : // parties_collect_list.totalAmounttoCollect.toLocaleString(
                            //   "en-IN"
                            // )
                            data.key == 2 &&
                              parties_pay_list &&
                              parties_pay_list.totalAmounttoPay !== null
                            ? "₹ " +
                              (parties_pay_list.totalAmounttoPay &&
                                parties_pay_list.totalAmounttoPay)
                            : // parties_pay_list.totalAmounttoPay.toLocaleString(
                              //   "en-IN"
                              // )
                              0}
                        </h1>
                      </div>
                    </div>
                  )}
                </Col>
              );
            })}
          </Row>
        </Col>
        <Col span={24} className="mb-3">
          <Row>
            <Col span={17} className="p-4 purchase-table-orders">
              <div
                className="border p-4"
                style={{
                  borderTopRightRadius: "4px",
                  borderTopLeftRadius: "4px",
                  borderBottomLeftRadius: "0px",
                  borderBottomRightRadius: "0px",
                }}
              >
                <h1
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className="text-[#7d7dab] font-semibold text-[14px]"
                >
                  Latest Transactions
                </h1>
              </div>
              <Table
                style={{
                  overflow: "hidden",
                  borderRadius: "0px",
                  fontFamily: "Poppins",
                }}
                bordered
                columns={HeaderData}
                dataSource={purchaseDataTable}
                sortDirections={"ascend"}
                loading={loading ? true : false}
                showSorterTooltip={"sorter-icon"}
                // scroll={{ y: 150 }}
                onChange={onChange}
                rowClassName="dashboard-label"
                rootClassName="dashboard-label"
                className="mt-[-4px] border-none"
                pagination={false}

                // scroll={{ y: 210, x: 765 }}
              />
              <div
                className="border border-x-1 border-t-0 border-b-1 p-4 mt-[0.2px] w-[100%] flex justify-center"
                style={{
                  borderBottomRightRadius: "4px",
                  borderBottomLeftRadius: "4px",
                  borderTopLeftRadius: "0px",
                  borderTopRightRadius: "0px",
                }}
              >
                <h1
                  style={{
                    fontFamily: "Poppins",
                  }}
                  onClick={() => {
                    history.push("/purchase-invoice");
                  }}
                  className="cursor-pointer text-[#4096ff] font-medium text-[13px]"
                >
                  See All Transactions
                </h1>
              </div>
            </Col>
            <Col span={7}>
              <Row className="pl-1 mb-5 mt-[-4px]">
                <Col span={24} className="">
                  {loading ? (
                    <Skeleton.Input
                      style={{
                        marginRight: "5px",
                        minWidth: "148%",
                        height: "55px",
                      }}
                      active={true}
                      size={"large"}
                    ></Skeleton.Input>
                  ) : (
                    <div
                      className={
                        "poppins flex mr-4 dashboard-card border rounded-md"
                      }
                    >
                      <div
                        style={{
                          fontSize: "14px",
                          fontFamily: "Poppins",
                        }}
                        className={
                          media === "md" || media === "sm" || media === "xs"
                            ? "flex flex-col"
                            : "flex"
                        }
                      >
                        <div className="flex">
                          <p>
                            <GiBank size={18} />
                          </p>
                          <h2 className={"ml-2"}>
                            {"Total Cash + Bank Balance"}
                          </h2>
                        </div>
                        <div
                          className={
                            media === "md"
                              ? "font-semibold flex text-[18px] ml-6"
                              : media === "sm" || media === "xs"
                              ? "font-semibold flex text-[18px] ml-3"
                              : "w-[100px] font-semibold flex text-[18px] pl-2"
                          }
                        >
                          <h1
                            style={{
                              fontFamily: "sans",
                              marginRight: "2px",
                            }}
                          >
                            {"₹ "}
                          </h1>
                          <h1>
                            {total_balance_list &&
                            total_balance_list.totalBalance !== undefined
                              ? total_balance_list.totalBalance &&
                                parseFloat(total_balance_list.totalBalance)
                                  .toFixed(2)
                                  .toLocaleString("en-IN")
                              : 0}
                          </h1>
                        </div>
                        {/* </div> */}
                        {/* <div> */}
                      </div>
                    </div>
                  )}
                </Col>
                <Col span={24} className="mt-4">
                  {loading ? (
                    <Skeleton.Input
                      style={{
                        marginRight: "5px",
                        minWidth: "148%",
                        height: "90px",
                      }}
                      active={true}
                      size={"large"}
                    ></Skeleton.Input>
                  ) : (
                    <div
                      className={
                        "poppins mr-4 dashboard-card border rounded-md"
                      }
                    >
                      <div
                        style={{
                          fontSize: "14px",
                          fontFamily: "Poppins",
                        }}
                        className={
                          media === "md" || media === "sm" || media === "xs"
                            ? "flex flex-col"
                            : "flex justify-between"
                        }
                      >
                        <div className="flex">
                          <p>
                            <RiStockFill size={18} />
                          </p>
                          <h2 className={"ml-2"}>{"Live Stock"}</h2>
                        </div>
                        <div
                          className={
                            media === "md"
                              ? "font-semibold flex text-[18px] ml-6"
                              : media === "sm" || media === "xs"
                              ? "font-semibold flex text-[18px] ml-3"
                              : "w-[100px] font-semibold flex text-[18px] pl-2"
                          }
                        >
                          <h1>
                            {total_balance_list &&
                            total_balance_list.totalLiveStocks !== undefined
                              ? total_balance_list.totalLiveStocks
                              : 0}
                          </h1>
                        </div>

                        {/* </div> */}
                        {/* <div> */}
                      </div>
                      <Divider
                        style={{
                          width: "110%",
                          marginTop: "5px",
                          marginBottom: "-3px",
                          marginLeft: "-13px",
                        }}
                      />
                      <div
                        style={{
                          fontSize: "14px",
                          fontFamily: "Poppins",
                        }}
                        className={
                          media === "md" || media === "sm" || media === "xs"
                            ? "flex mt-3 flex-col"
                            : "flex mt-3 justify-between"
                        }
                      >
                        <div className="flex">
                          <p>
                            <GiPriceTag size={18} />
                          </p>
                          <h2 className={"ml-2"}>{"Total Price"}</h2>
                        </div>
                        <div
                          className={
                            media === "md"
                              ? "font-semibold flex text-[18px] ml-6"
                              : media === "sm" || media === "xs"
                              ? "font-semibold flex text-[18px] ml-3"
                              : "w-[100px] font-semibold flex text-[18px] pl-2"
                          }
                        >
                          <h1
                            style={{
                              fontFamily: "sans",
                              marginRight: "2px",
                            }}
                          >
                            {"₹ "}
                          </h1>
                          <h1>
                            {total_balance_list &&
                            total_balance_list.totalLiveStocksPrice !==
                              undefined
                              ? total_balance_list.totalLiveStocksPrice &&
                                total_balance_list.totalLiveStocksPrice.toLocaleString(
                                  "en-IN"
                                )
                              : 0}
                          </h1>
                        </div>
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col span={24} className="mb-3">
          <Row>
            <Col span={17} className="p-4 purchase-table-orders">
              <div
                className="border p-4 flex"
                style={{
                  borderTopRightRadius: "4px",
                  borderTopLeftRadius: "4px",
                  borderBottomLeftRadius: "0px",
                  borderBottomRightRadius: "0px",
                }}
              >
                <h1
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className="text-[#7d7dab] font-semibold text-[14px]"
                >
                  Sales Report:
                </h1>
                <p
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className="pl-2 font-semibold text-[13px]"
                >
                  {beforeWeek} - {todayDate}
                </p>
              </div>
              <div
                className="border pt-3 border-t-0"
                style={{
                  borderTopRightRadius: "0px",
                  borderTopLeftRadius: "0px",
                  borderBottomLeftRadius: "4px",
                  borderBottomRightRadius: "4px",
                }}
              >
                {/* <Image
                  preview={false}
                  src={SalesReportImg}
                  height={170}
                  width={"80%"}
                /> */}
                <div className="dashboard-label w-[90%] h-[80%] p-2">
                  <ResponsiveContainer width="100%" height={300}>
                    <AreaChart data={formattedSalesData}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis
                        dataKey="date"
                        tickFormatter={(tick) => tick}
                        interval={0}
                        height={50}
                        padding={{ left: 20, right: 20 }}
                      />
                      <XAxis
                        dataKey="month"
                        axisLine={false}
                        tickLine={false}
                        interval={0}
                        xAxisId="monthAxis"
                        tick={{ dy: 10, fontWeight: "bold" }}
                      />
                      <YAxis />
                      <Tooltip />
                      <Area
                        type="monotone"
                        dataKey="totalAmount"
                        stroke="#48CAE4"
                        fill="#ADE8F4"
                        fillOpacity={0.5}
                      />
                    </AreaChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        {/* <Col span={24}>
          <Column {...config} />
        </Col> */}
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

export default Dashboard;
